import React from "react";
import IntegrationServices from "../../../../services/integration.services";
import { CheckBoxComp, ErrorTextComp } from "../../../inputs/fields.component";
import { TypeFaceText } from "../../../inputs/buttons.component";
import GoalServices from "../../../../services/goal.services";
import ImgIconComp from "../../../imgcomp";
import PermissionComp from "./permission.component";
import { reactLoader, removeReactLoader, constructNestedKRPayload } from "../../../../utils/common.js";
import KrAlignDependance from '../../../../components/okr/wizard/key_results/krAlignDependence';
import { useTranslation } from "react-i18next";
import NestedInlineComp from "./NestedInline.component";
import AddKrTag from "../../../../krTags/components/addkrTag.component"
import Customokr from './../../../custom_fields/customobj/Customokr';
import KrRelationshipWrapper from "./krRelationshipWrapper";
import { AddFinancialTargetsButton } from '../AddFinancialTargetsButton';
export default class MsPlanner extends React.Component {
	constructor(props) {
		super(props);
		let metricObj = {};
		if (Object.keys(this.props.item).length) {
			metricObj = this.props.item;
		}
		const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
		this.state = {
			metricObj,
			planners: [],
			errors: {},
			project_ids: [],
			teamPermissionSelected:
				this.props.item && this.props.item.permission_teams
					? this.props.item.permission_teams
					: [],
			bizPermissionSelected:  this.props.item && this.props.item.permission_biz ? this. props.item.permission_biz : [],
			permissionstate:
				this.props.item && this.props.item.permission
					? this.props.item.permission.split(",").map(Number)
					: this.props.goalDetails.type == 1 ? [8] : [10],
			permissionHelpPopUp: false,
			krAlingSelected: this.props.item &&
				this.props.item.kr_aligns !== undefined &&
				this.props.item.kr_aligns.length > 0
                ? this.props.item.kr_aligns
                : [],
			krDependenciesSelected: this.props.item &&
                this.props.item.kr_dependent !== undefined &&
                this.props.item.kr_dependent.length > 0
                ? this.props.item.kr_dependent
                : [],
			tags:[],
			nplTags:this.props.nplTags ? this.props.nplTags : [],
			selectednlplTags:this.props.selectednlplTags ? this.props.selectednlplTags : [],
			selectednlplTagsName:this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
			tagsList:this.props.tagsList ? this.props.tagsList:[],
			customInputData:[],
      		isCustomSave:[],
			  coOwners: isKrCoOwnerEnabled ? (this.props.item.coOwners && this.props.item.coOwners.length > 0 ? this.props.item.coOwners : (this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [])) : []
		};

		this.IntegrationServices = new IntegrationServices();
		this.GoalServices = new GoalServices();

		this.isEnabledMsPlanner = this.isEnabledMsPlanner.bind(this);
		this.renderResults = this.renderResults.bind(this);
		this.renderProjectRow = this.renderProjectRow.bind(this);
		this.renderPlannerRow = this.renderPlannerRow.bind(this);
		this.saveMsPlannerData = this.saveMsPlannerData.bind(this);
		this.changeProjectId = this.changeProjectId.bind(this);
		this.renderError = this.renderError.bind(this);
		this.permissionData = this.permissionData.bind(this);
		this.teamPermissionData = this.teamPermissionData.bind(this);
		this.saveAlignArr = this.saveAlignArr.bind(this);
		this.saveDependentArr = this.saveDependentArr.bind(this);
		this.updateTags = this.updateTags.bind(this);
		this.isRequiredCustomOkrFiled = this.isRequiredCustomOkrFiled.bind(this);
    	this.renderError = this.renderError.bind(this);
		this.saveMsPlannerDataCompleted = this.saveMsPlannerDataCompleted.bind(this);
	}

	componentDidMount() {
		let isEnabledMsPlanner = this.isEnabledMsPlanner();
		let _this = this;
		let metricId = _this.state.metricObj["id"] || -1;
		let params = { app: "ms_planner", metricId: metricId };
		if (isEnabledMsPlanner) {
			this.IntegrationServices.getMsPlannerData(params).then(response => {
				if (response.data) {
					let data = response.data.data || [];
					let mapping = response.data.mapping || {};
					let project_ids = [];
					if (
						typeof mapping["metric_projects"] != "undefined" &&
						typeof _this.state.metricObj["id"] != "undefined"
					) {
						let mettric_project_ids =
							typeof mapping["metric_projects"][metricId] != "undefined"
								? mapping["metric_projects"][metricId]
								: [];
						if (mettric_project_ids.length) {
							for (let s of mettric_project_ids) {
								var arrowChar = s.split("->");
								if (arrowChar.length > 1) {
									project_ids.push(arrowChar[1]);
								} else {
									project_ids.push(arrowChar[0]);
								}
							}
						}
					}
					_this.setState({ planners: data, project_ids });
				}
			});
		}
	}

	changeProjectId(e, item) {
		if (item) {
			let { planners, project_ids } = this.state;
			let chk = e.target.checked;
			const { id, parentID, child } = item;
			if (chk) {
				project_ids = [...project_ids, id];
				// if parent is selected, set all child values are selected
				if (!child) {
					let findPlanner = planners.find(p => p.id == id);
					if (findPlanner) {
						let findBuckets = findPlanner.buckets;
						if (findBuckets && findBuckets.length) {
							for (let b of findBuckets) {
								project_ids = [...project_ids, b.id];
							}
						}
					}
				} else {
					// if all child is selected, set parent value is selected
					let findPlanner = planners.find(p => p.id == parentID);
					if (findPlanner) {
						let findBuckets = findPlanner.buckets;
						let bucketIds = [];
						if (findBuckets && findBuckets.length) {
							for (let b of findBuckets) {
								bucketIds.push(b.id);
							}
						}
						const uniqueBucketIds = [...new Set(bucketIds)];
						if (uniqueBucketIds.length == project_ids.filter(val => uniqueBucketIds.includes(val)).length) {
							project_ids = [...project_ids, parentID];
						}
					}
				}
			} else {
				let parentChildeValues = [id];
				if (child) {
					// if child is unselected, set parent value is unselected
					parentChildeValues.push(parentID);
				} else {
					// if parent is unselected, set all child values are unselected
					let findPlanner = planners.find(p => p.id == id);
					if (findPlanner) {
						let findBuckets = findPlanner.buckets;
						if (findBuckets && findBuckets.length) {
							for (let b of findBuckets) {
								parentChildeValues.push(b.id);
							}
						}
					}
				}
				project_ids = project_ids.filter(val => !parentChildeValues.includes(val));
			}

			this.setState({ project_ids: [...new Set(project_ids)] });
		}
	}

	permissionData(perData) {
		this.setState({
			permissionstate: perData
		});
	}

	teamPermissionData(teamPerData) {
		this.setState({
			teamPermissionSelected: teamPerData
		});
	}

	bizPermissionData = (bizPerData) => {
    this.setState({
      bizPermissionSelected: bizPerData
    });
  }

	renderError(field) {
		return <ErrorTextComp errors={this.state.errors} field={field} />;
	}

	saveMsPlannerDataCompleted(callback = null, data = {}) {
		if (callback && typeof callback == "function") {
			callback(data);
		} else {
			this.props.closeKrRightPane(true);
		}
	}

	saveMsPlannerData(isError = false) {
		//console.log('saveMsPlannerData');
		let { project_ids, metricObj, planners } = this.state;
		let errors = {};
		let projectValues = {};
		//let metricName = $("#metric-name-text").val();
		let metricName = this.props.krText;
		this.isSaveCustom(this.state.customInputData)
		this.setState({isCustomSave:[]})
		const {t} = this.props;
		if( this.state.isRequirdCustomOkr && this.state.isRequirdCustomOkr.length>0  ){
		  errors["customokr"] = t(`Please enter required field`);
		  this.setState({isCustomSave:this.state.isRequirdCustomOkr})
		}

		if (
			typeof metricName === "undefined" ||
			metricName == null ||
			metricName == ""
		) {
			errors["metricName"] = true;
		}
		if (!project_ids.length) {
			errors["project_ids"] = t("Select a project");
		} else {
			for (let s of this.state.project_ids) {
				for (let p of planners) {
					if (p.id == s) {
						projectValues[p.id] = p.plan_id;
						break;
					} else {
						let findBucketPlan = p.buckets.find(f => f.id == s);
						if (findBucketPlan) {
							projectValues[findBucketPlan.bucket_id] =
								findBucketPlan.bucket_id;
							break;
						}
					}
				}
			}
			if (!Object.keys(projectValues).length) {
				errors["project_ids"] = t("Select a project");
			}
		}
		if (Object.keys(errors).length) {
			this.setState({ errors });
			if(errors.metricName){
				$('.krRightPaneContent').parent().animate({ scrollTop: 0 });
			} else if(errors.project_ids && errors.project_ids.length > 0){
				$('.krRightPaneContent').parent().animate({ scrollTop: $(".krRightPaneContent")[0].scrollHeight - 150 });
			}
		} else {
			let { actions, item, goalDetails, krText, krNote } = this.props;
			let goalId = goalDetails.id;
			if (typeof goalId !== "undefined") {
				let krId = "";
				let _this = this;
				let params = {};
				if (typeof item !== "undefined" && typeof item["id"] !== "undefined") {
					params.id = item["id"];
					krId = params.id;
				}
				params.name = krText;
				params.isQuarter  = this.props.isQuarter;
				params.kr_duration = this.props.kr_duration;
				params.description = krNote;
				params.source = 8;
				params.real_owner = this.props.realOwner.id;
				let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
				params.coOwners = coOwners.length > 0 ? Array.prototype.map
				  .call(coOwners, s => s.id)
				  .toString() : '';
				params.type = 1;
				let teaMperArr = [], bizPerArr = [];
				if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
					const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
					if (Array.isArray(permission_teams) && permission_teams.length) {
						teaMperArr = permission_teams.map(val => val.id);
					}
					if (Array.isArray(permission_biz) && permission_biz.length) {
						bizPerArr = permission_biz.map(val => val.id);
					}
				} else {
					if (
						this.state.teamPermissionSelected &&
						this.state.teamPermissionSelected.length > 0
					) {
						teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
					}
					if (
						this.state.bizPermissionSelected &&
						this.state.bizPermissionSelected.length > 0
					) {
						bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
					}
				}
				params.permission_teams = teaMperArr;
				params.permission_biz = bizPerArr;

				if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
					params.permission = this.props.goalDetails.permission;
				} else {
					params.permission = Array.prototype.map
						.call(this.state.permissionstate, s => s)
						.toString(); // "A,B,C";
				}
				params.ext_app_id = 11;
				params.project_ids = projectValues;
				let exclude = document.getElementById("msplanner_exclude").checked;
				params.progress_consider = exclude == true ? 0 : 1;
				
				let krAlignSel = this.state.krAlingSelected;
				let dependentKrsSel = this.state.krDependenciesSelected;
				let krAligns = [];
				let dependentKrs = [];

				if (Object.keys(krAlignSel).length > 0) {
				  krAlignSel.map(item => {
					krAligns.push(item.id);
				  });
				}
				params["nested_krs"] = constructNestedKRPayload(this.props);
				if (Object.keys(dependentKrsSel).length > 0) {
				  dependentKrsSel.map(item => {
					dependentKrs.push(item.id);
				  });
				}
				params.krAligns = krAligns;
				params.dependentKr = dependentKrs;
				let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
				let tagids=this.state.tags.length ? this.state.tags : ['']
				let finalTagsIds = [...nlpIds,...tagids]
				params.krTagIds = finalTagsIds;
				// console.log('params -->', params);
				if (!isError) {
					if(this.props.isChildKr && this.props.fromParentKr){
						params.duration = this.props.childKrDuration;
						params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
          				params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
						if(this.props.item.parent){
							params.parent = this.props.item.parent;
						}
						params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
						this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
					} else if(this.props.mitChildKr){
						params.duration = this.props.childKrDuration;
						params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
						params.real_owner_picture = this.props.showRealOwner ? this.props.realOwner.avatar : "";
						params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
						params.end_date = this.props.item.end_date;
          				params.start_date = this.props.item.start_date;
						this.props.saveQuarterlyKR(params, this.props.mitIndex);
						this.saveMsPlannerDataCompleted(typeof callback === 'undefined'? null : callback, params);
						// this.props.closeKrRightPane();
					} else{
						if(this.props.item.parent){
							params.start_date = this.props.childKrDuration.start ;
							params.end_date = this.props.childKrDuration.end;
							params.parent = this.props.item.parent;
						}
						params.isQuarter  = this.props.isQuarter;
						params.kr_duration = this.props.kr_duration;
						params.customField=JSON.stringify(this.props.customFieldsData);
						reactLoader(true);
						this.GoalServices.addEditKr({ goalId: goalId, metric: params }).then(
							response => {
								removeReactLoader();
								if (response.data) {
									if (!this.props.onlyMetEdit) {
										let result = response.data.data;
										let krWeightage = null;
										if (result.krWeightage) {
											krWeightage = result.krWeightage;
											delete result['krWeightage'];
										}
										if(result.parent){
											actions.addUpdateNestedKr(result)
										}else{
											if (krId) {
												actions.editNewKr(krId, result);
											} else {
												actions.addNewKr(result);
											}
										}
										
										if (krWeightage) {
											_this.props.MetricChangeWeight(krWeightage);
										}
									}
									this.saveMsPlannerDataCompleted(typeof callback === 'undefined'? null : callback, response.data.data);
									// _this.props.closeKrRightPane(true);
									// this.GoalServices.triggerGoalMetricDetails({goalId});
								}
							}
						);
					}
				}
			}
		}
	}

	isEnabledMsPlanner() {
		let { goalDetails = {} } = this.props;
		let isEnabledMsPlanner = false;
		if (
			typeof goalDetails["externalApps"] != "undefined" &&
			goalDetails["externalApps"] != null
		) {
			isEnabledMsPlanner =
				typeof goalDetails["externalApps"]["ms_planner"] != "undefined" &&
					goalDetails["externalApps"]["ms_planner"]
					? true
					: false;
		}
		return isEnabledMsPlanner;
	}

	renderResults() {
		let { planners, project_ids } = this.state;
		if (Array.isArray(planners) && planners.length) {
			return planners.map(planner =>
				this.renderProjectRow(planner, project_ids)
			);
		}
	}

	renderProjectRow(planner, project_ids = []) {
		let isChecked = project_ids.find(p => p == planner.id) ? 
		true : false;
		return (
			<div>
				{this.renderPlannerRow({ ...planner, checked: isChecked })}
				{typeof planner["buckets"] != "undefined"
					? planner["buckets"].map(p =>
						this.renderPlannerRow({
							...p,
							child: true,
							parentID: planner.id,
							checked: project_ids.includes(p.id),
						})						
					)
					: ""}
			</div>
		);
	}

	renderPlannerRow(planner) {
		let { id, name, child = false, checked = false, disabled = false, parentID } = planner;
		let childClass = child ? " rollup-planner-child-table " : "";
		let chkProps = {};
		chkProps.item = planner;
		chkProps.onChange = this.changeProjectId;
		chkProps.checkboxProps = {
			checked: checked,
			disabled: disabled
		};
		let checkboxId = id + "_" + checked;
		return (
			<div className={"rollup-table rollup-planner-table " + childClass}>
				<div className="rollup-row">
					<div className="rollup-col rollup-checkbox">
						<CheckBoxComp key={checkboxId} id={id} {...chkProps} subclassDefined={'displayInLineBlk'}/>
					</div>
					<div className="rollup-col rollup-col-title">
						<div className="rollup-title">
							<div className="showtooltip-title" title={name}>
								{name}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	MSPRedirect() {
		setTimeout(() => this.props.closeKrRightPane(), 500);
		window.open(wbConfig.baseUrl + "/user/profile/edit?do=mgInt", "_blank");
	}
	saveAlignArr(alignData){
		this.setState({
		  krAlingSelected: alignData
		})
	}
	saveDependentArr(dependentData){
		this.setState({
		  krDependenciesSelected: dependentData
		})
	}
	saveTag = (childData) =>{
		this.setState({tags:childData})
	}

	isSaveCustom(isVal){
		let arr=[];
		let j=0;
		let keyArrCategory=[]
		let valArray = []
		isVal && Object.keys(isVal).forEach((v)=>{
		  j++;
		  isVal[v]["customFields"]&&
		  Object.keys(isVal[v]["customFields"]).forEach(objv=>{
			keyArrCategory.push(objv)
			if(isVal[v]["customFields"][objv]['is_required']=='1'
			&&( isVal[v]["customFields"][objv]["text"]  ==undefined || isVal[v]["customFields"][objv]["text"]  ==[])
			){
				 arr.push(objv,v)
				} 
			if(isVal[v]["customFields"][objv]["text"]){
			  valArray.push(isVal[v]["customFields"][objv]["text"])
			}else{
			  valArray.push('')
				}
		  })
		  if(j==Object.keys(isVal).length){
			this.setState({isRequirdCustomOkr:[...arr]})
		  }  
		  let finalDataArray=[]
		  for(let i=0;i<valArray.length;i++){
			if(Array.isArray(valArray[i])){
			  valArray[i].forEach(val => {
				finalDataArray.push({id:keyArrCategory[i],val:val.name,object_type:'6'})
			  })
			}
			else{
			  finalDataArray.push({id:keyArrCategory[i],val:valArray[i],object_type:'6'})
			}
			 
		  }
		  const tempData=finalDataArray
		})
		
	  }
	
	  isRequiredCustomOkrFiled(isVal,id){
		let cust_id=this.state.isCustomSave.find((u) => u == id);
		let ar=this.state.isCustomSave ? this.state.isCustomSave:'';
		let fr= ar.filter(
			(u) => u != cust_id
		  )
		this.setState({isCustomSave:fr})
		this.isSaveCustom(isVal)
		this.setState({customInputData:isVal})
	  }
	
	  renderError(field) {
		return (
		  <ErrorTextComp key={field} errors={this.state.errors} field={field} />
		);
	  }

	updateTags(Newtags){
		this.setState({
		  selectednlplTagsName: Newtags
		})
	}
	render() {
		const {t} = this.props;
		let metricObj = this.state.metricObj;
		//let isEnabledMsPlanner = this.isEnabledMsPlanner();
		let mspLogin = this.props.mspLogin;
		let excludeObj = false;
		if (metricObj.ext_app_id == '11' && this.props.kpiType == 'ms') {
			if (metricObj.progress_consider == "0" || metricObj.progress_consider == false) {
				excludeObj = true;
			}
		}
		let closeAsaFunc = this.props.mspClosePopUp;
		return (
			<div className="msplanner-wrapper-comp">
				<div className="fieldcontent">
					{mspLogin ? (
						<MSPlannerPromoComp
							key="msplanner_promo"
							MSPRedirect={this.MSPRedirect}
							mspClosePopUp={closeAsaFunc}
						/>
					) : (
							<div className="">
								<div className="wherekrDataCome">
									{t('Select which MS Planner projects you want to measure?')}
                					<TypeFaceText key="typeface" />
								</div>
								<div className="msplanner-project-list">
									{this.renderResults()}
								</div>
								{this.renderError("project_ids")}
								{(this.props.customData && Object.keys(this.props.customData).length > 0 && !this.props.mitChildKr ) && <div className="krBreak" style={{marginBottom:"-10px"}} aria-hidden="true" />}
								{  ((this.props.addOkrData.groupKRCustomFields|| this.props.groupKRCustomFields) && !this.props.mitChildKr )&& 
										<Customokr
											customData={this.props.customData}
											isRequiredCustomOkrFiled={this.isRequiredCustomOkrFiled}
											onCustomDataChange={(newData) => this.props.onCustomFieldsChange?.(newData)}
											customFiledRequired={true}
											renderError={this.renderError}
											isCustomSave={this.state.isCustomSave}
										/>
								}
								{
									!this.props.isChildKr && !this.props.mitChildKr &&
									<div className="breakline" />
								}
								{    
									(this.props.addOkrData.display_nested_kr && 
									!this.props.isChildKr && !this.props.mitChildKr &&
									Math.ceil(moment(this.props.goalDetails.target_date).diff(moment(this.props.goalDetails.start_date), "days", true)) >= 360) &&
									<NestedInlineComp
									{...this.props}
									actions = {this.props.actions}
									nested_krs = {this.props.nested_krs}
									updateNestedKrs = {this.props.updateNestedKrs}
									/>
								}
								<AddFinancialTargetsButton objectType="kr" objectId={this.props.item?.id} ownerUserId={this.props.realOwner?.id} />
								{!this.props.mitChildKr && <KrRelationshipWrapper {...this.props} metric={this.props.item} saveKr={this.saveMsPlannerData}/>}
								{
									!this.props.isChildKr && !this.props.mitChildKr &&
									<>
										<KrAlignDependance {...this.props} 
										saveDependentArr={this.saveDependentArr}
										saveAlignArr={this.saveAlignArr}
										krAlingArr={this.props.item.kr_aligns} 
										krDependenciesArr={this.props.item.kr_dependent}/>
										<AddKrTag metric={this.props.item} goalId={this.props.goalDetails.id} taghandler={this.saveTag}
										nplTags={this.state.nplTags}  selectednlplTags={this.state.selectednlplTags} selectednlplTagsName={this.state.selectednlplTagsName} updateTags={this.updateTags} tagsList={this.state.tagsList} searchText={this.props.krText}
										/>
										<div className="fieldcontent">
											<CheckBoxComp
												id="msplanner_exclude"
												subclassDefined = "displayInLineBlk"
												key={"msplanner_exclude_obj_" + excludeObj}
												checkboxProps={{ defaultChecked: excludeObj }}
												label={t(`Exclude from objective progress calculation`)}
											/>
										</div>
									</>
								}
								
								{this.props.goalDetails && this.props.goalDetails.all_metrics == "0" && !this.props.mitChildKr ? (
									<div className="pT10">
										<div className="viewPermissionArea">
											<span>
												{t('View permissions in addition to')}{" "}
												{this.props.goalDetails.type == 1 ? t(" team ") : t(" owner ")}
												<div className="metricTargetHelptext permissionHelpText"
													onMouseEnter={event => {
														this.setState({ permissionHelpPopUp: true });
													}}
													onMouseLeave={event => {
														this.setState({ permissionHelpPopUp: false });
													}}
												/>
												{this.state.permissionHelpPopUp && (
													<div className="basic-popup">
														{t(`You can give your whole organization permission to view your Key Result, or just your team and managers`)}
												</div>
												)}
											</span>
										</div>
										<div className="pB10">
											<PermissionComp
												{...this.props}
												teamPermissionData={this.teamPermissionData}
												bizPermissionData={this.bizPermissionData}
												permissionData={this.permissionData}
												hide={false}
											/>
										</div>
									</div>
								) : (
										""
									)}
							</div>
						)}
				</div>
			</div>
		);
	}
}

const MSPlannerPromoComp = props => {
	const { t, i18n } = useTranslation();
	let closeFunc = props.mspClosePopUp
	return (
		<div id="myModal" className="aEmodal mspOverLay">
			<div className="ws-import-login-assana msPLogin">
				<div>
					<img
						width="150px"
						src={wbConfig.baseUrl + "/images/icons/microsoft-planner.svg"}
					/>
					<div
						className="closeGitPopup right clickable"
						onClick={(e) => closeFunc(e)}
					>
						<ImgIconComp id="close" class="jiraLogoExtraMar" />
					</div>
				</div>
				<div className="login-popup-row">
					<div className="msp-popup-col padding6 lable">
						{t("Allow WorkBoard to access your MS Planner's account")}
          		</div>
				</div>
				<div id="asanHelpPopup" />
				<div className="login-popup-row">
					<div className="msp-popup-col2">
						<div className="mspLogin-input-label">
							{t('Please follow the steps')}{" "}
							<span className="link" onClick={() => props.MSPRedirect()}>
								{t('here')}
              				</span>{" "}
							{t('to integrate Microsoft Planner into WorkBoard.')}
			            </div>
					</div>
				</div>
			</div>
		</div>
	);
};
